import colors from '../../../constants/colors'

const buttonsGroupStyle = {
  '&.MuiToggleButtonGroup-root': {
    width: '100%',
    border: 'none',
  },
}

const buttonBorderRight = {
  borderRight: `1px solid ${colors.TAG_LINES_GRAY}`,
}

const buttonsGroupButton = {
  display: 'flex',
  gap: '.5rem',
  width: '33%',
  border: 'none',
  color: colors.BLACK,
  '&.Mui-selected': {
    backgroundColor: colors.TAG_PURPLE_BOX_FILL,
    color: colors.BLACK,
  },
  '&:active': {
    backgroundColor: colors.TAG_PURPLE_BOX_FILL,
    color: colors.BLACK,
  },
  '&.Mui-selected:hover': {
    backgroundColor: colors.TAG_PURPLE_BOX_FILL,
    color: colors.BLACK,
  },
}

export default {
  buttonsGroupButton,
  buttonsGroupStyle,
  buttonBorderRight,
}
